import Backbone from 'backbone';
import ShoppingCartItem from './ShoppingCartItem';
import $ from 'jquery';

export default Backbone.Collection.extend({
    initialize: function (models, options) {
        this.model = ShoppingCartItem;
        this.shoppingCart = options.shoppingCart;
    },

    url: function () {
        return `${this.shoppingCart.url()}/items?_csrf=${$('meta[name="_csrf_token"]').attr('content')}`;
    }
});



// WEBPACK FOOTER //
// ./model/ShoppingCartItems.js